export class BrandInfoDTO{
    // key:string="ABC";
    id:string='';
    isDeleted:boolean=false;
    brandName:string='';
    brandDescription:string='';
    brandLogoUrl:string='';
}